/** @jsxImportSource @emotion/react */
import { useEffect } from "react";
import { css } from "@emotion/react";

import {
  Header,
  NavigationBar,
  Footer,
  MatterFunction,
} from "./components/patterns";
import { Intro, Map, NotFound, Studios } from "./components/screens";
import { Stack } from "@mui/material";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const App = () => {
  return (
    <Stack>
      <BrowserRouter>
        <Header />
        <NavigationBar />
        <Routes>
          <Route path="/" element={<Studios />}></Route>
          <Route path="/map" element={<Map />}></Route>
          <Route path="/intro" element={<Intro />}></Route>
          <Route path="/studios" element={<MatterFunction />}></Route>
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
        <Footer />
      </BrowserRouter>
    </Stack>
  );
};

export default App;
